// Central config for the current promotional sale.
// The actual discount is applied at Shopify checkout via this exact code.
export const SALE = {
  enabled: false,
  code: "FREESHIP",
  // Evergreen offer — no end date (set a date string to re-add a deadline).
  endsAt: null,
  headline: "Free Shipping",
  subline: "on all US orders",
  cta: "/shop",
};

export const saleActive = () => SALE.enabled;
